import { render, staticRenderFns } from "./aiAssessment.vue?vue&type=template&id=c2c770c0&scoped=true&"
import script from "./aiAssessment.vue?vue&type=script&lang=js&"
export * from "./aiAssessment.vue?vue&type=script&lang=js&"
import style0 from "./aiAssessment.vue?vue&type=style&index=0&id=c2c770c0&prod&lang=less&scoped=true&"
import style1 from "./aiAssessment.vue?vue&type=style&index=1&id=c2c770c0&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c770c0",
  null
  
)

export default component.exports